import { find, uniqBy, sortBy, first, get } from 'lodash';

export const buildDriveOptions = (options, driveTypes) => {
  const driveOptions = options.map(option => {
    const { driveType, rearWheelType } = option;
    const { icon, iconClass, lowestMSRP } = find(driveTypes, { id: driveType });
    return {
      id: `${driveType}-${rearWheelType}`,
      driveType,
      icon,
      iconClass,
      rearWheelType,
      msrp: lowestMSRP
    };
  });
  const uniqueDriveOptions = uniqBy(driveOptions, 'id');
  return sortBy(uniqueDriveOptions, 'msrp');
};

export const combineWithConfig = config => options =>
  options.map(option => {
    const engineDescription = get(
      find(config.engines, { id: option.engine }),
      'description'
    );
    const bodyTypes = config.bodyTypes
      .filter(x => x.id === option.bodyTypeId)
      .map(x => ({
        bodyTypeDescription: x.formattedConfig,
        cabSize: get(x, 'cabSize', '')
      }));
    const bodyType = first(bodyTypes);
    return {
      ...option,
      styleId: `${option.styleId}`,
      engineDescription,
      ...bodyType
    };
  });
